import { OptionType } from "@/types/OptionType";
import { ClientDto } from "./client.dto";

function formatClientOptionSubtitle(client: ClientDto): string | undefined {
  const subtitleParts: string[] = [];

  if (client.sapCode?.trim()) {
    subtitleParts.push(`SAP: ${client.sapCode.trim()}`);
  }

  if (client.vatNumber?.trim()) {
    subtitleParts.push(`CIF: ${client.vatNumber.trim()}`);
  }

  return subtitleParts.length > 0 ? subtitleParts.join(" · ") : undefined;
}

export function mapClientToOptionType(client: ClientDto): OptionType {
  return {
    label: client.name,
    value: client.id,
    subtitle: formatClientOptionSubtitle(client),
  };
}
